import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  subscriptionLevel: Yup.string().required("Subscription level required."),
});

export default validationSchema;
